// The Reset · Portal configuration
// Edit these values to update what members see on the dashboard.

export const RETREAT_DATE = new Date('2026-07-23T00:00:00');
export const RESET_2027_DATE = new Date('2027-08-12T00:00:00');

// Interest / learn-more mailto — pre-filled subject + body
const INTEREST_SUBJECT =
  'I want to learn more about Reset 2027 and joining the Monthly Brotherhood Meet Up';
const INTEREST_BODY =
  'Hey Neil,\n\nI\u2019m interested in learning more about The Reset 2027 retreat and joining the Monthly Brotherhood Circle. Please send me details.\n\nThanks,\n';
export const INTEREST_EMAIL = 'nalvanzo@gmail.com';
export const INTEREST_MAILTO = `mailto:${INTEREST_EMAIL}?subject=${encodeURIComponent(
  INTEREST_SUBJECT,
)}&body=${encodeURIComponent(INTEREST_BODY)}`;

// Next Brotherhood Meeting — recurs on the LAST SATURDAY of every month,
// 10:00 AM EST, through June 2027. Auto-calculates the next occurrence.
// The series starts on the first-ever Circle: September 26, 2026 at 10:00 AM EST.
const MEETING_START = new Date('2026-09-26T10:00:00'); // First-ever Circle
const MEETING_END = new Date('2027-06-30T23:59:59'); // series ends after June 2027

function lastSaturdayOf(year, monthIdx) {
  const d = new Date(year, monthIdx + 1, 0); // last day of month
  const day = d.getDay(); // 0=Sun, 6=Sat
  const offset = (day - 6 + 7) % 7;
  d.setDate(d.getDate() - offset);
  d.setHours(10, 0, 0, 0);
  return d;
}

function computeNextMeeting() {
  const now = new Date();
  // If the series hasn't kicked off yet, always show the first meeting.
  if (now < MEETING_START) return MEETING_START;
  let year = now.getFullYear();
  let month = now.getMonth();
  let next = lastSaturdayOf(year, month);
  // If this month's last Saturday already passed, go to next month
  if (next < now) {
    month += 1;
    if (month > 11) {
      month = 0;
      year += 1;
    }
    next = lastSaturdayOf(year, month);
  }
  if (next > MEETING_END) return null; // series concluded
  return next;
}

function formatMeetingDate(d) {
  return d.toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

const _nextMeetingDate = computeNextMeeting();

export const NEXT_MEETING = _nextMeetingDate
  ? {
      title: 'Monthly Brotherhood Circle',
      date: formatMeetingDate(_nextMeetingDate),
      time: '10:00 AM EST · 60 minutes',
      theme:
        'Last Saturday of every month · a place to check in, be seen, and stay accountable',
      zoomUrl: 'https://zoom.us/j/00000000000',
      isoDate: _nextMeetingDate.toISOString(),
      recurring: 'Last Saturday of every month through June 2027',
      concluded: false,
    }
  : {
      title: 'Monthly Brotherhood Circle',
      date: 'Series concluded',
      time: 'Ran through June 2027',
      theme: 'The monthly circle has completed its run. New rhythm coming soon.',
      zoomUrl: '#',
      isoDate: null,
      recurring: 'Last Saturday of every month · June 2026 \u2013 June 2027',
      concluded: true,
    };

// Rotating daily reflections — one is shown per day (by day-of-year)
export const REFLECTIONS = [
  {
    quote:
      'You cannot pour from an empty cup. Refill it before the world asks for more.',
    author: 'Reset · On Rest',
  },
  {
    quote:
      'Purpose does not shout. It whispers in the quiet you keep avoiding.',
    author: 'Reset · On Purpose',
  },
  {
    quote:
      'Wealth is not what you accumulate. It is what you can pass on with intention.',
    author: 'Reset · On Legacy',
  },
  {
    quote: 'Self-care is not indulgence. It is infrastructure.',
    author: 'David Girton · The HEALth Debt Coach™',
  },
  {
    quote:
      'Real brothers don\u2019t just show up when you\u2019re winning. They show up when you\u2019re quiet.',
    author: 'Reset · On Brotherhood',
  },
  {
    quote: 'Discipline is a love letter to your future self.',
    author: 'Reset · On Discipline',
  },
  {
    quote:
      'You are not behind. You are exactly where the work you\u2019ve done put you.',
    author: 'Neil Alvanzo · On Purpose',
  },
  {
    quote: 'The reset happens in the pause, not the sprint.',
    author: 'Reset · On Rest',
  },
  {
    quote:
      'Money is a tool. What you build with it says everything about who you are.',
    author: 'DeWayne Ellis · The Wealth Syndicate',
  },
  {
    quote: 'Legacy is what happens when you refuse to be the last of your kind.',
    author: 'Reset · On Legacy',
  },
  {
    quote:
      'The body keeps the score. Move it, breathe with it, listen when it whispers.',
    author: 'David Girton · LiveNow Fitness',
  },
  {
    quote:
      'You cannot heal what you refuse to feel. Sit with it. Then get up and build.',
    author: 'Reset · On Growth',
  },
];

// September 2026 topics + guest speaker
export const CIRCLE_FOCUS = {
  headline: 'Who Controls the Future?',
  intro:
    'A month dedicated to one question Black men can\u2019t afford to skip: how AI is reshaping power, who holds it, and the moves our community needs to make right now.',
};

// Rotating monthly guest-speaker roster (YYYY-MM keys).
// Add a new entry each month; missing months automatically show "To be announced".
export const MONTHLY_SPEAKERS = {
  '2026-09': {
    name: 'Adam Harte',
    handle: 'Who Controls the Future?',
    credentials: 'Enterprise AI Strategy \u00b7 AI Governance',
    role: 'Enterprise AI Strategy & Governance Advisor',
    bio: 'An Enterprise AI strategy and governance advisor who helps leaders stand up responsible, large-scale AI programs \u2014 and who still believes every good system starts with one clear owner.',
    bio_long:
      'Adam Harte is an Enterprise AI Strategy and AI Governance advisor who partners with executives to design the operating models, controls, and accountability structures that make large-scale AI programs actually work. A recovering program manager and new father, he brings an unapologetically opinionated view to his craft: every good system starts with a clear owner \u2014 while leaving just enough room for the chaos that surfaces the gaps worth fixing. He opens the Circle this fall with a conversation Black men can\u2019t afford to miss \u2014 how AI is reshaping power, who holds it, and the moves our community needs to make right now.',
    quote:
      'Every good system starts with a clear owner \u2014 and just enough chaos to find the holes.',
    quote_note:
      'The talk: Who Controls the Future? Black Men & the Rise of AI.',
    href: '/speakers/adam-harte',
    image:
      'https://customer-assets-4nw71qhi.emergentagent.net/job_analytics-live-1/artifacts/2x9ios9b_image.png',
    tagline: 'Who Controls the Future? Black Men & the Rise of AI.',
  },
  '2026-10': {
    name: 'Adam Harte',
    handle: 'Black Men, AI & Power',
    credentials: 'Enterprise AI Strategy \u00b7 AI Governance',
    role: 'Enterprise AI Strategy & Governance Advisor',
    bio: 'An Enterprise AI strategy and governance advisor who helps leaders stand up responsible, large-scale AI programs \u2014 and who still believes every good system starts with one clear owner.',
    bio_long:
      'Adam Harte is an Enterprise AI Strategy and AI Governance advisor who partners with executives to design the operating models, controls, and accountability structures that make large-scale AI programs actually work. A recovering program manager and new father, he brings an unapologetically opinionated view to his craft: every good system starts with a clear owner \u2014 while leaving just enough room for the chaos that surfaces the gaps worth fixing. In October he joins the Circle to lead a conversation Black men can\u2019t afford to miss \u2014 how AI is reshaping power, who holds it, and the moves our community needs to make right now.',
    quote:
      'Every good system starts with a clear owner \u2014 and just enough chaos to find the holes.',
    quote_note:
      'The talk: Black Men, AI & Power \u2014 a conversation we need to have.',
    href: '/speakers/adam-harte',
    image:
      'https://customer-assets-4nw71qhi.emergentagent.net/job_analytics-live-1/artifacts/2x9ios9b_image.png',
    tagline: 'Black Men, AI & Power: A Conversation We Need to Have.',
  },
};

export function getSpeakerForMeeting(date) {
  if (!date) return null;
  const d = date instanceof Date ? date : new Date(date);
  const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
  const monthLabel = d.toLocaleString('en-US', { month: 'long', year: 'numeric' });
  const s = MONTHLY_SPEAKERS[key];
  if (s) return { ...s, confirmed: true, monthKey: key, monthLabel };
  return {
    name: 'Guest speaker coming soon',
    handle: 'To be announced',
    bio: 'We\u2019re finalizing this month\u2019s guest. Check back soon.',
    href: null,
    image: null,
    tagline: null,
    confirmed: false,
    monthKey: key,
    monthLabel,
  };
}

// Legacy alias — points to the speaker for the current NEXT meeting.
export const CIRCLE_GUEST_SPEAKER = _nextMeetingDate
  ? getSpeakerForMeeting(_nextMeetingDate)
  : {
      name: 'Guest speaker coming soon',
      handle: 'To be announced',
      bio: 'We\u2019re finalizing this month\u2019s guest. Check back soon.',
      href: null,
      confirmed: false,
    };

export const CIRCLE_TOPICS = [
  {
    title: 'Where AI Is Already Changing the Game',
    desc: 'Jobs, wealth, media, education \u2014 what\u2019s already moved, and what\u2019s moving next for Black men.',
  },
  {
    title: 'Who Holds the Keys',
    desc: 'Big Tech, government, open-source, and venture: a plain-English map of who\u2019s actually deciding the rules.',
  },
  {
    title: 'The Brother\u2019s Playbook',
    desc: 'Practical moves this month \u2014 tools to adopt, skills to build, and conversations to have at work and at home.',
  },
  {
    title: 'Our Seat at the Table',
    desc: 'What Black men need to demand \u2014 in boardrooms, policy, and our own communities \u2014 to shape where this ends up.',
  },
];

export const CIRCLE_PRICE = 25;

// The 9 quick links that appear on the portal home + sidebar
export const QUICK_LINKS = [
  {
    key: 'founder',
    title: 'The Founder',
    desc: 'Neil Alvanzo \u00b7 story of The Reset',
    href: '/welcome/neil',
    color: 'from-[#D4AF37] to-amber-300',
    image:
      'https://customer-assets-4nw71qhi.emergentagent.net/job_analytics-live-1/artifacts/8inhc1di_neil_photo.webp',
    imageAlt: 'Neil Alvanzo, founder of The Reset',
  },
  {
    key: 'reset-2026',
    title: 'The Reset 2026',
    desc: 'Complete \u00b7 registration closed',
    href: '/promo',
    external: false,
    color: 'from-[#D4AF37] to-amber-300',
    closed: true,
  },
  {
    key: 'reset-2027',
    title: 'The Reset 2027',
    desc: 'Aug 12\u201314, 2027 \u00b7 Panama',
    href: '/portal/reset-2027',
    color: 'from-amber-300 to-[#8C6239]',
    featured: true,
  },
  {
    key: 'monthly-meeting',
    title: 'Monthly Meeting',
    desc: 'Brotherhood circle',
    href: '/portal/monthly-meeting',
    color: 'from-emerald-400 to-teal-500',
  },
  {
    key: 'meditation',
    title: 'Meditation',
    desc: 'Guided stillness',
    href: '/portal/meditation',
    color: 'from-teal-400 to-cyan-500',
  },
  {
    key: 'coaching',
    title: 'Coaching',
    desc: 'Talk to a facilitator',
    href: '/portal/coaching',
    color: 'from-indigo-400 to-blue-500',
  },
  {
    key: 'health-wellness',
    title: 'Health & Wellness',
    desc: 'Body, breath, sleep',
    href: '/portal/health-wellness',
    color: 'from-rose-400 to-pink-500',
  },
  {
    key: 'financial-wellness',
    title: 'Financial Wellness',
    desc: 'Money, purpose, legacy',
    href: '/portal/financial-wellness',
    color: 'from-yellow-300 to-orange-400',
  },
  {
    key: 'resources',
    title: 'Resources',
    desc: 'Reading, PDFs, tools',
    href: '/portal/resources',
    color: 'from-slate-300 to-slate-500',
  },
  {
    key: 'community',
    title: 'Community',
    desc: 'Connect with brothers',
    href: '/portal/community',
    color: 'from-violet-400 to-fuchsia-500',
  },
  {
    key: 'interested',
    title: 'Interested? Reach out',
    desc: 'Tell me more about the retreat',
    href: INTEREST_MAILTO,
    external: true,
    color: 'from-emerald-300 to-teal-400',
  },
];

export function getTodayReflection() {
  const now = new Date();
  const start = new Date(now.getFullYear(), 0, 0);
  const dayOfYear = Math.floor((now - start) / (1000 * 60 * 60 * 24));
  return REFLECTIONS[dayOfYear % REFLECTIONS.length];
}

export function getReflectionForOffset(offsetDays) {
  const now = new Date();
  now.setDate(now.getDate() + offsetDays);
  const start = new Date(now.getFullYear(), 0, 0);
  const dayOfYear = Math.floor((now - start) / (1000 * 60 * 60 * 24));
  const reflection = REFLECTIONS[dayOfYear % REFLECTIONS.length];
  return {
    ...reflection,
    date: now,
    label: now.toLocaleDateString('en-US', {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
    }),
  };
}

// Reset 2026 photo set — used on Portal Home tiles (2027 countdown + Brotherhood Circle).
export const RESET_2026_PHOTOS = [
  {
    src: 'https://customer-assets-4nw71qhi.emergentagent.net/job_analytics-live-1/artifacts/7skeeo05_PXL_20260726_004540194.MP.webp',
    alt: 'Brothers at the Panama City waterfront under string lights',
    location: 'Panama City waterfront',
  },
  {
    src: 'https://customer-assets-4nw71qhi.emergentagent.net/job_analytics-live-1/artifacts/nznk02k7_PXL_20260725_185730181.webp',
    alt: 'Brothers on the seaside walkway, arms around shoulders',
    location: 'Playa Bonita seafront',
  },
  {
    src: 'https://customer-assets-4nw71qhi.emergentagent.net/job_analytics-live-1/artifacts/g7mkkk7i_PXL_20260725_193333031.webp',
    alt: 'Brothers at the Marcus Mosiah Garvey statue',
    location: 'Marcus Garvey monument, Panama',
  },
  {
    src: 'https://customer-assets-4nw71qhi.emergentagent.net/job_analytics-live-1/artifacts/0d51cdwr_PXL_20260725_193314657.webp',
    alt: 'Brothers at the PANAMÁ sign',
    location: 'PANAMÁ sign, Flamenco Marina',
  },
];

export function getGreeting() {
  const h = new Date().getHours();
  if (h < 12) return 'Good morning';
  if (h < 17) return 'Good afternoon';
  return 'Good evening';
}

export function daysUntilRetreat() {
  const today = new Date();
  return Math.max(0, Math.ceil((RETREAT_DATE - today) / (1000 * 60 * 60 * 24)));
}

export function daysUntil2027() {
  const today = new Date();
  return Math.max(0, Math.ceil((RESET_2027_DATE - today) / (1000 * 60 * 60 * 24)));
}
